/*
 * @Author: 范向玲
 * @Date: 2022-12-08 14:05:44
 * @LastEditors: 范向玲
 * @LastEditTime: 2023-01-10 17:14:44
 * @Description: 国内外大型矿业公司-数据管理表格配置
 * @FilePath: \src\components\DataManagement\management\tableConfig.js
*/
const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial', },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '最大持股方',
    dataIndex: 'ownerName',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'ownerName', },
  },
  {
    title: '中文名称',
    dataIndex: 'name',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'name', },
  },
  {
    title: '英文名称',
    dataIndex: 'nameEn',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'nameEn', },
  },
  {
    title: '排名',
    dataIndex: 'num',
    ellipsis: true,
    align: 'center',
    width: 100,
    slots: { customRender: 'num', },

  },
  {
    title: '项目数',
    dataIndex: 'count',
    ellipsis: true,
    align: 'center',
    width: 200,
    slots: { customRender: 'count', },
  },
  {
    title: '更新时间',
    dataIndex: 'createTime',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action', },
    align: 'center',
    width: 180,
  },
];

const screenTableConfig = [
  {
    title: '排名',
    dataIndex: 'num',
    ellipsis: true,
    // width: 60,
    align: 'center',
  },
  {
    title: '中文名称',
    dataIndex: 'name',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '英文名称',
    dataIndex: 'nameEn',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '项目数',
    dataIndex: 'count',
    ellipsis: true,
    align: 'center',
    // width: 200,
  },
  {
    title: '更新时间',
    dataIndex: 'createTime',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action', },
    align: 'center',
    // width: 180,
  },
];

export { tableConfig, screenTableConfig, };
